/* eslint-disable react/display-name */

import ForgotPasswordController from './ForgotPasswordController'

export default ForgotPasswordController
